__turbopack_context__.v({
  "centeredColumn": "centered-column-module__ObNarW__centeredColumn",
});
